import { logParamKey, paymentItemParamKey, paymentParamKey, Route } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'number',
        direction: 'desc',
    })
}

export enum CompanyReceiptRouteName {
    Index = 'company.receipts.index',
    Edit = 'company.receipts.edit',
    Show = 'company.receipts.show',
    Logs = 'company.receipts.logs',
    LogDetails = 'company.receipts.logs.details',
    Send = 'company.receipts.send',
    Items = 'company.receipts.items',
    EditItem = 'company.receipts.items.edit',
    ItemLogs = 'company.receipts.items.logs',
    ItemLogDetails = 'company.receipts.items.logs.details',
}

export default {
    path: 'receipts',
    name: CompanyReceiptRouteName.Index,
    component: () => import('@/views/company/receipt/Index.vue'),
    meta: {
        label: 'Company Receipts',
        auth: true,
        permission: Permission.ReceiptViewAny,
    },
    children: [
        {
            path: `:${paymentParamKey}/edit`,
            name: CompanyReceiptRouteName.Edit,
            component: () => import('@/views/company/receipt/Index.vue'),
            meta: {
                label: 'Edit Receipt',
                auth: true,
                permission: Permission.ReceiptUpdate,
            },
        },
        {
            path: `:${paymentParamKey}/send`,
            name: CompanyReceiptRouteName.Send,
            component: () => import('@/views/company/receipt/Index.vue'),
            meta: {
                label: 'Send Receipt',
                auth: true,
                permission: Permission.ReceiptSend,
            },
        },
        {
            path: `:${paymentParamKey}`,
            name: CompanyReceiptRouteName.Show,
            component: () => import('@/views/company/receipt/Index.vue'),
            meta: {
                label: 'Receipt Details',
                auth: true,
                permission: Permission.ReceiptView,
            },
            children: [
                {
                    path: 'items',
                    name: CompanyReceiptRouteName.Items,
                    component: () => import('@/views/company/receipt/Index.vue'),
                    meta: {
                        label: 'Payment Items',
                        auth: true,
                        permission: Permission.PaymentItemViewAny,
                    },
                    children: [
                        {
                            path: `:${paymentItemParamKey}/edit`,
                            name: CompanyReceiptRouteName.EditItem,
                            component: () => import('@/views/company/receipt/Index.vue'),
                            meta: {
                                label: 'Edit Payment Item',
                                auth: true,
                                permission: Permission.PaymentItemUpdate,
                            },
                        },
                        {
                            path: `:${paymentItemParamKey}/logs`,
                            name: CompanyReceiptRouteName.ItemLogs,
                            component: () => import('@/views/company/receipt/Index.vue'),
                            meta: {
                                label: 'Payment Item Logs',
                                auth: true,
                                permission: Permission.EventViewAny,
                            },
                            children: [
                                {
                                    path: `:${logParamKey}`,
                                    name: CompanyReceiptRouteName.ItemLogDetails,
                                    component: () => import('@/views/company/receipt/Index.vue'),
                                    meta: {
                                        label: 'Log Details',
                                        auth: true,
                                        permission: Permission.EventView,
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            path: `:${paymentParamKey}/logs`,
            name: CompanyReceiptRouteName.Logs,
            component: () => import('@/views/company/receipt/Index.vue'),
            meta: {
                label: 'Receipt Logs',
                auth: true,
                permission: Permission.EventViewAny,
            },
            children: [
                {
                    path: `:${logParamKey}`,
                    name: CompanyReceiptRouteName.LogDetails,
                    component: () => import('@/views/company/receipt/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                },
            ],
        },
    ],
}
